import { lsSet } from '@modules/localStorage/methods/lsSet';
import { LocalStorageKeys } from '@modules/localStorage/types/localStorageKeys.type';

export const setChatVisibility = (bool: boolean) =>
	lsSet(LocalStorageKeys.CHAT_VISIBLE, bool);
